export default {
  breakpoints: {
    desktop: 1024,
    desktopMedium: 1280,
    desktopWide: 1600,

    mobile: 320,
    mobileMedium: 375,
    mobileWide: 425,

    tablet: 768,
  },
  defaultBreakpoints: {
    desktop: 'desktop',
    mobile: 'mobile',
    tablet: 'tablet',
  },
  fallbackBreakpoint: 'destop',
}

export function resize(type: 'mobile' | 'desktop') {
  if(type === 'desktop') return;
  const designWidth = 750 // 设计稿宽度
  const baseFontSize = designWidth / 10 
  const screenWidth = document.documentElement.clientWidth
  const fontSize = (screenWidth / designWidth) * baseFontSize
  const minFontSize = 12 // 最小字体
  const maxFontSize = 75 // 最大字体（设计稿 1:1 时）
  document.documentElement.style.fontSize =
    `${Math.min(Math.max(fontSize, minFontSize), maxFontSize)}px`
}


